import { render, staticRenderFns } from "./ContractRedeem.vue?vue&type=template&id=03615bea&scoped=true&"
import script from "./ContractRedeem.vue?vue&type=script&lang=js&"
export * from "./ContractRedeem.vue?vue&type=script&lang=js&"
import style0 from "./ContractRedeem.vue?vue&type=style&index=0&id=03615bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03615bea",
  null
  
)

export default component.exports